// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Divider,
//   Paper,
//   Stack,
//   Chip,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   CircularProgress,
// } from "@mui/material";
// import RecordProfilePage from "../../components/RecordProfilePage";
// import { useLocation, useParams } from "react-router-dom";
// import { fetchSampleActivity } from "../../utils/api";

// const TAMU_MAROON = "#500000";
// const BORDER_COLOR = "#dcdcdc";

// const SampleProfile = () => {
//   const { sampleId } = useParams();
//   const { state } = useLocation();
//   const [activity, setActivity] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const sample = state?.sample || {
//     barcode: sampleId,
//     collectedAt: "MM/DD/YYYY",
//     type: "Blood Plasma",
//     quality: "Good",
//     totalAliquots: 10,
//     participantName: "—",
//   };

//   useEffect(() => {
//     const loadActivity = async () => {
//       if (!sampleId) {
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);
//         const activityData = await fetchSampleActivity(sampleId);
//         if (activityData && Array.isArray(activityData)) {
//           setActivity(activityData);
//         } else {
//           setActivity([]);
//         }
//       } catch (error) {
//         console.error("Error loading sample activity:", error);
//         setActivity([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadActivity();
//   }, [sampleId]);

//   return (
//     <RecordProfilePage title="Sample Profile" backTo="/admin/samples" maxWidth={1200}>
//       <Paper
//         variant="outlined"
//         sx={{ borderRadius: 0, p: 2, mb: 2, borderColor: BORDER_COLOR }}
//       >
//         <Typography sx={{ fontSize: "1.25rem", fontWeight: 800, mb: 1 }}>
//           {sample.barcode}
//         </Typography>
//         <Divider sx={{ mb: 2 }} />

//         <Stack direction="row" spacing={4} useFlexGap flexWrap="wrap">
//           <Info label="Sample Type" value={sample.type} />
//           <Info label="Collection Date" value={sample.collectedAt} />
//           <Info label="Quality" value={<Chip label={sample.quality} size="small" />} />
//           <Info
//             label="Total Aliquots Processed"
//             value={sample.totalAliquots ?? 10}
//           />
//           <Info
//             label="Participant Name"
//             value={sample.participantName ?? "Hayley Johnston"}
//           />
//         </Stack>
//       </Paper>

//       <Typography
//         sx={{
//           display: "inline-block",
//           px: 1.5,
//           py: 0.75,
//           borderRadius: 20,
//           background: "#eee",
//           fontWeight: 700,
//           color: "#000",
//           mb: 1,
//         }}
//       >
//         SAMPLE ACTIVITY
//       </Typography>

//       <Paper
//         variant="outlined"
//         sx={{ borderRadius: 0, borderColor: BORDER_COLOR }}
//       >
//         <Table size="small">
//           <TableHead sx={{ background: "#e0e0e0" }}>
//             <TableRow>
//               <TableCell sx={{ fontWeight: 700 }}>Activity</TableCell>
//               <TableCell sx={{ fontWeight: 700, width: 180 }}>Date</TableCell>
//               <TableCell sx={{ fontWeight: 700, width: 140 }}>Time</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow>
//                 <TableCell colSpan={3} align="center">
//                   <CircularProgress size={24} />
//                 </TableCell>
//               </TableRow>
//             ) : activity.length > 0 ? (
//               activity.map((activityItem, i) => (
//                 <TableRow key={i}>
//                   <TableCell>{activityItem.activity || activityItem[0]}</TableCell>
//                   <TableCell>{activityItem.date || activityItem[1] || "MM/DD/YYYY"}</TableCell>
//                   <TableCell>{activityItem.time || activityItem[2] || "9:00 AM"}</TableCell>
//                 </TableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={3} align="center">
//                   <Typography variant="body2" color="textSecondary">
//                     No activity data available
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </Paper>
//     </RecordProfilePage>
//   );
// };

// const Info = ({ label, value }) => (
//   <Box>
//     <Typography sx={{ fontSize: ".85rem", fontWeight: 700, color: "#444" }}>
//       {label}:
//     </Typography>
//     <Typography sx={{ fontSize: ".95rem" }}>{value ?? "—"}</Typography>
//   </Box>
// );

// export default SampleProfile;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  Paper,
  Stack,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import RecordProfilePage from "../../components/RecordProfilePage";
import { useLocation, useParams } from "react-router-dom";
import { fetchSampleActivity, fetchPatientById } from "../../utils/api";

const TAMU_MAROON = "#500000";
const BORDER_COLOR = "#dcdcdc";

const SampleProfile = () => {
  const { sampleId } = useParams();
  const { state } = useLocation();
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  const sample = state?.sample || {
    barcode: sampleId,
    collectedAt: "MM/DD/YYYY",
    type: "Blood Plasma",
    quality: "Good",
    totalAliquots: 10,
  };

  const [participantName, setParticipantName] = useState("—");

  useEffect(() => {
    const loadPatientName = async () => {
      if (!sample.patientId) {
        setParticipantName("—");
        return;
      }

      try {
        const patient = await fetchPatientById(sample.patientId);
        const name = patient
          ? [patient.firstName, patient.lastName].filter(Boolean).join(" ")
          : "";
        setParticipantName(name || "—");
      } catch (error) {
        console.error("Error loading patient name:", error);
        setParticipantName("—");
      }
    };

    loadPatientName();
  }, [sample.patientId]);

  useEffect(() => {
    const loadActivity = async () => {
      if (!sampleId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const activityData = await fetchSampleActivity(sampleId);
        if (activityData && Array.isArray(activityData)) {
          setActivity(activityData);
        } else {
          setActivity([]);
        }
      } catch (error) {
        console.error("Error loading sample activity:", error);
        setActivity([]);
      } finally {
        setLoading(false);
      }
    };

    loadActivity();
  }, [sampleId]);

  return (
    <RecordProfilePage
      title="Sample Profile"
      backTo="/admin/samples"
      maxWidth={1200}
    >
      <Paper
        variant="outlined"
        sx={{ borderRadius: 0, p: 2, mb: 2, borderColor: BORDER_COLOR }}
      >
        <Typography sx={{ fontSize: "1.25rem", fontWeight: 800, mb: 1 }}>
          {sample.barcode}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Stack direction="row" spacing={4} useFlexGap flexWrap="wrap">
          <Info label="Sample Type" value={sample.type} />
          <Info label="Collection Date" value={sample.collectedAt} />
          <Info
            label="Quality"
            value={<Chip label={sample.quality} size="small" />}
          />
          <Info
            label="Total Aliquots Processed"
            value={sample.totalAliquots ?? 10}
          />
          <Info label="Participant Name" value={participantName} />
        </Stack>
      </Paper>

      <Typography
        sx={{
          display: "inline-block",
          px: 1.5,
          py: 0.75,
          borderRadius: 20,
          background: "#eee",
          fontWeight: 700,
          color: "#000",
          mb: 1,
        }}
      >
        SAMPLE ACTIVITY
      </Typography>

      <Paper
        variant="outlined"
        sx={{ borderRadius: 0, borderColor: BORDER_COLOR }}
      >
        <Table size="small">
          <TableHead sx={{ background: "#e0e0e0" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Activity</TableCell>
              <TableCell sx={{ fontWeight: 700, width: 180 }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 700, width: 140 }}>Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : activity.length > 0 ? (
              activity.map((activityItem, i) => (
                <TableRow key={i}>
                  <TableCell>
                    {activityItem.activity || activityItem[0]}
                  </TableCell>
                  <TableCell>
                    {activityItem.date || activityItem[1] || "MM/DD/YYYY"}
                  </TableCell>
                  <TableCell>
                    {activityItem.time || activityItem[2] || "9:00 AM"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No activity data available
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </RecordProfilePage>
  );
};

const Info = ({ label, value }) => (
  <Box>
    <Typography sx={{ fontSize: ".85rem", fontWeight: 700, color: "#444" }}>
      {label}:
    </Typography>
    <Box sx={{ fontSize: ".95rem" }}>{value ?? "—"}</Box>
  </Box>
);

export default SampleProfile;
